import React, { FC } from 'react';
import { useParams } from 'react-router';
import { LinearProgress } from '@mui/material';
import AuthorEditor from '@components/Authors/AuthorsEditor/AuthorForm';
import { useAuthorQuery } from './gql/AuthorsEditor.generated';
import PageContainer from '@components/UI/PageContainer/PageContainer';

const AuthorsEditorPage: FC = () => {
  const { uid } = useParams<{ uid: string }>();
  const { data, loading, error } = useAuthorQuery({
    variables: { uid },
    fetchPolicy: 'cache-and-network',
  });
  if (loading) {
    return (
      <PageContainer>
        <LinearProgress color="primary" />
      </PageContainer>
    );
  }

  if (error || !data?.author) {
    return (
      <PageContainer>
        <div>Автор не найден</div>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <AuthorEditor author={data.author} />
    </PageContainer>
  );
};

export default AuthorsEditorPage;